/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddCompanyMatchBypassRequest = {
  type: 'CompanyMatchBypass',
} as const;
